import { currencies } from '../../../core/const/currencies';
import { FrontSelect } from '../../../ui-components';

interface IProps {
  currency: string;
  onCurrencyChange: (currency: { value: string; label: string }) => void;
}

export const CurrencySelect = ({ currency, onCurrencyChange }: IProps) => {
  return (
    <FrontSelect
      minWidth={'96px'}
      placeholder="Select Currency"
      value={{ value: currency, label: currency }}
      options={currencies}
      name="currencySelect"
      getOptionLabel={(option) => `${option.label}`}
      getOptionValue={(option) => option.value}
      onChange={(option) => option && onCurrencyChange(option)}
      isMulti={false}
      isSearchable={true}
      isLoading={false}
      noOptionsMessage={() => 'No Currencies Available'}
    />
  );
};
